import styled from 'styled-components';
import { Menu } from 'components/atoms/dropdown';

export const CpMenu = styled(Menu)`
  border-right: none;
  padding: var(--spacing-03) 0;
  ${Menu.Header} {
    padding-top: var(--spacing-05);
    padding-bottom: var(--spacing-05);
    padding-left: var(--cp-spacing-05);
    padding-right: var(--cp-spacing-05);
    margin-bottom: 0;
  }
  .ant-menu-item {
    padding-left: var(--cp-spacing-05);
    padding-right: var(--cp-spacing-05);
    margin-top: 0;
    margin-bottom: 0;
    @media (min-width: 481px) {
      :hover {
        background: var(--cp-gray-10);
        color: var(--cp-gray-100);
      }
    }
    &.ant-menu-item-selected {
      @media (min-width: 481px) {
        :hover {
          background: var(--cp-blue-20-hover);
          color: var(--cp-blue-60);
        }
      }
    }
  }
`;
